import React from "react";
import { Field, FieldProps, FieldRenderProps } from "react-final-form";
import { InputGroup, InputGroupText } from "reactstrap";
import "./TextField.scss";

export interface ITextFieldProps<FieldValue>
  extends FieldProps<
    FieldValue,
    FieldRenderProps<FieldValue, HTMLInputElement | HTMLTextAreaElement>
  > {
  label?: string;
  light?: boolean;
  type?: string;
  appendText?: string;
  prependText?: string;
  placeholder?: string;
  multiline?: boolean; // Render a textarea if true
  bare?: boolean; // render only the input
  inputProps?: any;
}

const TextField: React.FC<ITextFieldProps<string>> = ({
  label,
  light,
  appendText,
  prependText,
  disabled,
  placeholder,
  multiline,
  bare,
  inputProps,
  ...fieldProps
}) => {
  // Adjust class based on props
  const baseClass = disabled
    ? "text-field-disabled-v2"
    : light
    ? "text-field-light-v2"
    : "text-field-dark-v2";

  if (bare) {
    return (
      <Field {...fieldProps}>
        {({ input, meta }) => (
          <div className={`${baseClass} ${meta.error ? "error" : ""}`}>
            <InputGroup>
              <input
                {...(input as React.InputHTMLAttributes<HTMLInputElement>)}
                {...inputProps}
                disabled={disabled}
                placeholder={placeholder}
              />
            </InputGroup>
          </div>
        )}
      </Field>
    );
  }

  return (
    <Field {...fieldProps}>
      {({ input, meta }) => (
        <div className={baseClass}>
          <ul>
            {label && (
              <li>
                <label>{label}</label>
              </li>
            )}
            <li>
              <InputGroup>
                {prependText && <InputGroupText>{prependText}</InputGroupText>}
                {multiline ? (
                  <textarea
                    {...(input as React.TextareaHTMLAttributes<HTMLTextAreaElement>)}
                    className={"textarea-custom"}
                    disabled={disabled}
                    placeholder={placeholder}
                  />
                ) : (
                  <input
                    {...(input as React.InputHTMLAttributes<HTMLInputElement>)}
                    {...inputProps}
                    disabled={disabled}
                    placeholder={placeholder}
                  />
                )}
                {meta.touched && meta.error && <span>{meta.error}</span>}
                {appendText && <InputGroupText>{appendText}</InputGroupText>}
              </InputGroup>
            </li>
          </ul>
        </div>
      )}
    </Field>
  );
};

export default TextField;
